module.exports = __webpack_public_path__ + "img/lucky.ab6a801c.jpg";